<template>
  <v-container>
    <link
      rel="stylesheet"
      href="https://leaflet.github.io/Leaflet.markercluster/dist/MarkerCluster.css"
    />
    <link
      rel="stylesheet"
      href="https://leaflet.github.io/Leaflet.markercluster/dist/MarkerCluster.Default.css"
    />

    <v-row>
      <v-col cols="12" sm="12" md="4" lg="3" xl="2">
        <v-row>
          <v-col>
            <h4>Select Dates:</h4>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-date-picker
            v-model="getSelectedDates"
            multiple
            :allowed-dates="allowedDates"
            @input="updateFilterDates"
          ></v-date-picker>
        </v-row>
        <v-row>
          <v-col>
            <h4>{{ getFilteredImages.length + " images selected." }}</h4>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn width="100%" @click="deleteAllDates()" color="error"
              ><v-icon left>mdi-close-outline</v-icon>Remove all dates</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn width="100%" @click="selectAllDates()" color="primary"
              ><v-icon left>mdi-checkbox-multiple-marked-outline</v-icon>Select
              all dates</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn @click="downloadAllImages()" width="100%"
              ><v-icon left>mdi-download</v-icon
              >{{ "Download " + getFilteredImages.length + " images" }}</v-btn
            >
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12" sm="6" md="4" lg="6" xl="7">
        <v-card height="100%">
          <div id="container">
            <div id="mapContainer"></div>
          </div>
        </v-card>
      </v-col>

      <v-col cols="12" sm="6" md="4" lg="3" xl="3">
        <v-row style="height: 6vh"
          ><v-col>
            <v-select
              :items="items"
              item-text="value"
              item-value="key"
              label="Sort By"
              v-model="order"
              dense
            ></v-select></v-col
        ></v-row>

        <v-row style="height: 85vh" class="overflow-y-auto">
          <v-col
            cols="12"
            v-for="image in getOrderedImages"
            v-bind:key="image.id"
            justify=""
            ><div :id="image.id">
              <v-hover v-slot="{ hover }">
                <!-- <v-card
                target="_blank"
                rel="noopener noreferrer"
                :href="require('../assets/' + image.assets.full.href)"
                width="100%"
                max-width="400px"
                style="cursor: pointer"
                :elevation="hover ? 16 : 2"
              > -->
                <v-card
                  width="100%"
                  max-width="500px"
                  :elevation="hover ? 16 : 2"
                >
                  <v-card-title>
                    <v-img
                      :src="getThumbnailUrl(image.assets.tn400x400.href)"
                      class="white--text align-end text-center"
                      gradient="to bottom, rgba(0,0,0,.05), rgba(0,0,0,.2)"
                      height="200px"
                    >
                      <v-card-title>
                        <!-- <v-chip-group :show-arrows="true" dark>
                        <v-chip
                          dark
                          color="green"
                          v-for="k in image.properties.keywords"
                          v-bind:key="k"
                          >{{ k }}</v-chip
                        >
                      </v-chip-group> -->
                        <v-chip>{{ image.id }}</v-chip>
                        <v-spacer></v-spacer>

                        <v-btn
                          icon
                          dark
                          @click="downloadImage(getOriginalUrl(image.id))"
                          ><v-icon left>mdi-download</v-icon></v-btn
                        >

                        <v-btn
                          target="_blank"
                          rel="noopener noreferrer"
                          :href="getOriginalUrl(image.id)"
                          icon
                          dark
                          ><v-icon left>mdi-fullscreen</v-icon></v-btn
                        >
                      </v-card-title>
                    </v-img>
                  </v-card-title>

                  <!-- <v-card-text>{{
                  new Date(image.properties.datetime).toDateString()
                }}</v-card-text> -->
                  <!-- <v-card-text
                  >{{ image.properties["caption/abstract"] }}
                </v-card-text> -->
                  <v-card-actions>
                    {{ new Date(image.properties.datetime).toDateString() }}

                    <v-spacer></v-spacer>
                    <v-btn @click="openDialog(image)" color="primary"
                      ><v-icon left>mdi-text-box-search-outline</v-icon
                      >Details</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-hover>
            </div>
          </v-col></v-row
        >
      </v-col>
    </v-row>
    <DetailDialog
      :dialog.sync="dialog"
      v-bind:feature="activeImage"
    ></DetailDialog>
    <v-overlay :value="overlay" class="text-center">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
      <h4>
        Downloading multiple images may require few seconds. Please wait...
      </h4>
    </v-overlay>
  </v-container>
</template>

<script>
import "leaflet/dist/leaflet.css";
import "leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.webpack.css";
import L from "leaflet";
import "leaflet-defaulticon-compatibility";
import * as L1 from "leaflet.markercluster";
import icon from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";
import { mapGetters, mapActions } from "vuex";
import CustomPopup from "../components/CustomPopup.vue";
import DetailDialog from "../components/DetailDialog.vue";
import axios from "axios";
import Vue from "vue";
import JSZip from "jszip";
import { saveAs } from "file-saver";
/* import Vuetify from "vuetify"; */

const HOST_ORIGINAL = process.env.VUE_APP_ORIGINAL_PHOTOS;
const HOST_THUMBNAILS = process.env.VUE_APP_THUMBNAILS;

export default {
  data: () => ({
    mapDiv: null,
    center: [23, -43],
    dates: [],
    menu: false,
    activeImage: null,
    dialog: false,
    overlay: false,
    order: "descending",
    items: [
      { key: "descending", value: "Date - Most recent photos first" },
      { key: "ascending", value: "Date - Oldest photos first" },
    ],
  }),
  components: { DetailDialog },
  computed: {
    allowedDatesList() {
      return [
        ...new Set(
          this.getImages.map(
            (i) => new Date(i.properties.datetime).toISOString().split("T")[0]
          )
        ),
      ];
    },
    ...mapGetters(["getImages", "getSelectedDates", "getFilteredImages"]),
    getOrderedImages() {
      if (this.order == "ascending") {
        return this.getFilteredImages.slice().sort(this.sortAscending);
      } else {
        return this.getFilteredImages.slice().sort(this.sortDescending);
      }
    },
    geoJSONmarkers() {
      var thisData = this.getFilteredImages;
      let geoJSONdata = thisData;

      let geoJSONcollection = {
        type: "FeatureCollection",
        features: geoJSONdata,
      };

      const _this = this;

      var geoJsonLayer = L.geoJson(geoJSONcollection, {
        onEachFeature: function (feature, layer) {
          layer
            .bindPopup(() => {
              var ComponentClass = Vue.extend(CustomPopup);
              /* var isSelected = _this.selected.indexOf(feature.properties) > -1; */
              var instance = new ComponentClass({
                /* vuetify: new Vuetify(), */
                propsData: { feature: feature },
              });
              instance.$mount();
              return instance.$el.innerHTML;
            })
            .on("popupopen", (a) => {
              window.location.href = `#${feature.id}`;
              var popUp = a.target.getPopup();

              popUp
                .getElement()
                .querySelector(".opendialog")
                .addEventListener("click", () => {
                  _this.openDialog(feature);
                });

              popUp
                .getElement()
                .querySelector(".downloadimage")
                .addEventListener("click", () => {
                  _this.downloadImage(HOST_ORIGINAL + feature.id + ".jpg");
                });

              /*
              popUp
                .getElement()
                .querySelector(".selectmap")
                .addEventListener("click", () => {
                  const index = _this.selected.indexOf(feature.properties);
                  if (index > -1) {
                    _this.selected.splice(index, 1);
                  } else {
                    _this.selected.push(feature.properties);
                  }
                  _this.mapDiv.closePopup();
                }); */
            });
        },
      });
      /* var geoJsonLayer = L.geoJson(geoJSONcollection); */
      var markers = new L1.MarkerClusterGroup({ showCoverageOnHover: true });
      markers.addLayer(geoJsonLayer);

      return markers;
    },
  },
  watch: {
    geoJSONmarkers(newMarkers, oldMarkers) {
      if (this.mapDiv != null) {
        this.mapDiv.removeLayer(oldMarkers);
        this.mapDiv.addLayer(newMarkers);
      }
    },
  },
  methods: {
    getThumbnailUrl(path) {
      return HOST_THUMBNAILS + path;
    },
    getOriginalUrl(path) {
      return HOST_ORIGINAL + path + ".jpg";
    },
    updateFilterDates(e) {
      this.$store.commit("updateFilterDates", e);
      this.$store.commit("applyFilters");
    },
    deleteAllDates() {
      this.$store.commit("updateFilterDates", []);
      this.$store.commit("applyFilters");
    },
    selectAllDates() {
      this.$store.commit("updateFilterDates", this.allowedDatesList);
      this.$store.commit("applyFilters");
    },
    allowedDates(val) {
      return this.allowedDatesList.indexOf(val) !== -1;
    },
    ...mapActions(["fetchImages"]),
    async downloadAllImages() {
      this.overlay = true;
      try {
        var zip = new JSZip();
        var folder = zip.folder("data");
        for (const imgidx in this.getFilteredImages) {
          let image = this.getFilteredImages[imgidx];
          let url = HOST_ORIGINAL + image.id + ".jpg";

          const response1 = await axios.get(url);
          folder.file(image.id + ".jpg", response1.data);
        }

        /* lipd.file(item.dataset_title + ".paleo0measurement0.csv", response1.data); */

        await zip.generateAsync({ type: "blob" }).then(function (content) {
          // see FileSaver.js
          saveAs(content, "images.zip");
        });
        this.overlay = false;
      } catch (error) {
        console.log(error);
        this.overlay = false;
      }
    },
    downloadImage(iurl) {
      axios({
        url: iurl, //your url
        method: "GET",
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", iurl.split("/").pop()); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
    },
    sortDescending(a, b) {
      if (a.properties.datetime > b.properties.datetime) {
        return -1;
      }
      if (a.properties.datetime < b.properties.datetime) {
        return 1;
      }
      return 0;
    },
    sortAscending(a, b) {
      if (a.properties.datetime < b.properties.datetime) {
        return -1;
      }
      if (a.properties.datetime > b.properties.datetime) {
        return 1;
      }
      return 0;
    },
    /*  downloadImage(image){

    }, */
    openDialog(item) {
      this.activeImage = item;
      this.dialog = true;
    },
    closeDialog() {
      this.activeImage = null;
      this.dialog = false;
    },
    setupLeafletMap() {
      const DefaultIcon = L.icon({
        iconUrl: icon,
        shadowUrl: iconShadow,
      });

      L.Marker.prototype.options.icon = DefaultIcon;
      this.mapDiv = L.map("mapContainer").setView(this.center, 3);
      L.tileLayer(
        "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
        {
          attribution:
            'Map data (c) <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery (c) <a href="https://www.mapbox.com/">Mapbox</a>',
          maxZoom: 18,

          minZoom: 1,
          /* scrollWheelZoom: false, */
          id: "mapbox/streets-v11",
          accessToken:
            "pk.eyJ1IjoiYWxlbW9yaSIsImEiOiJja2U0MmdkZHowcDFyMnhwZGc0dWgxNTIwIn0.AZJzeynr-RH04CF2OEuAoQ",
        }
      ).addTo(this.mapDiv);
      /* this.mapDiv.scrollWheelZoom.disable(); */
    },
    populateLeafletMap() {
      this.mapDiv.addLayer(this.geoJSONmarkers);
      /* this.mapDiv.fitBounds(this.geoJSONmarkers.getBounds()); */

      /* this.mapDiv.addEventListener("mousemove", function (ev) {
        console.log(ev.latlng.lat,ev.latlng.lng);
        
      }); */
    },
    async createMap() {
      /* await this.fetchPaleodata(); */
      await this.fetchImages();
      await this.setupLeafletMap();
      this.populateLeafletMap();
    },
  },

  mounted() {
    this.dates = this.allowedDatesList;
    this.createMap();
  },
};
</script>


<style scoped>
html {
  scroll-behavior: smooth;
}
#mapContainer {
  width: 100%;
  z-index: 0;
  height: 91vh;
}
</style>
